import React, { Component } from 'react';
import { UsersService } from '../../services/user';
import './faq.css';

import {
  HeaderShelf,
  SidebarRoundedIcons,
  Footer
} from '../../components';

import appStoreLogo from './AppStore.png';
import googlePlayLogo from './GooglePlay.png';

export default class ViewFaq extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      isUserLoggedIn: false
    };
  }

  componentDidMount() {
    const user = UsersService.getUser();
    this.setState({ isUserLoggedIn: user !== null });
  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/";
  }

  async signOut() {
    await UsersService.signOut()
    window.location = window.location.origin + window.location.pathname + "#/login";
  }

  render() {
    const { loading, isUserLoggedIn } = this.state;
    
    if (loading) {
      return (
        <div className="rdp-react-template-view-faq">
          <div className="rdp-react-template-view-faq-loading">
            <div className="rdp-react-template-view-faq-loader"></div>
          </div>
        </div>
      );
    }

    return (
      <div className="rdp-react-template-view-faq">
        <div className="rdp-react-template-view-faq-header">
          <HeaderShelf
            onSignOut={() => this.signOut()}
            renderSearch={false}
            isUserLoggedIn={isUserLoggedIn}
          />
        </div>

        {isUserLoggedIn && (
          <div className="rdp-react-template-view-faq-sidebar">
            <SidebarRoundedIcons />
          </div>
        )}

        <div className="rdp-react-template-view-faq-main">
          <div className="rdp-react-template-view-faq-container">
            <div className="rdp-react-template-view-faq-header-section">
              <h1 className="rdp-react-template-view-faq-title">Dúvidas frequentes</h1>
            </div>

            <div className="rdp-react-template-view-faq-content">
              <div className="rdp-react-template-view-faq-question">
                <h2>Como encontro um livro na plataforma?</h2>
                <p>
                  Você pode realizar a busca pelo título do livro, nome do autor,
                  número de ISBN ou mesmo termos do livro, além de utilizar
                  ferramentas para busca avançada. Basta digitar na barra de pesquisa
                  localizada na parte superior da página. Também é possível encontrar
                  obras navegando pelas categorias localizada na seção "Explore todo o
                  acervo". Caso não encontre o livro que deseja, envie uma mensagem
                  pelo <a href="#/contact">FALE CONOSCO</a>.
                </p>
              </div>

              <div className="rdp-react-template-view-faq-question">
                <h2>Preciso estar conectado à internet para ler um livro?</h2>
                <p>
                  Não. Por meio do aplicativo Biblioteca Digital Senac é possível
                  baixar livros para leitura off-line em seu smartphone ou tablet.
                  Acesse o aplicativo com seu login e senha e, enquanto ainda estiver
                  conectado à internet, escolha e clique no título desejado. Na janela
                  que será aberta, clique na opção "Leitura off-line", espere o
                  término do download e pronto! Aproveite seus estudos em qualquer
                  lugar, sem precisar de uma conexão com a rede.
                </p>
                <p>
                  Para baixar e instalar o aplicativo Biblioteca Digital Senac, acesse
                  pelo seu smartphone ou tablet as lojas de aplicativos.
                </p>
                <div className="wrapper-icon-store">
                  <a
                    style={{ marginRight: '1rem' }}
                    href="https://play.google.com/store/apps/details?id=br.com.senac.editoradigital"
                  >
                    <img alt="" width={100} className="google-play-logo" src={googlePlayLogo} />
                  </a>
                  <a href="https://apps.apple.com/br/app/biblioteca-digital-senac/id1474822168">
                    <img className="app-store-logo" width={100} src={appStoreLogo} alt="" />
                  </a>
                </div>
              </div>

              <div className="rdp-react-template-view-faq-question">
                <h2>Posso fazer o download de um livro para meus estudos?</h2>
                <p>
                  Você pode realizar seus estudos pelo smartphone ou tablet com o
                  aplicativo Biblioteca Digital Senac, que inclui a opção de leitura
                  off-line. Para baixar e instalar o aplicativo Biblioteca Digital
                  Senac, acesse pelo seu smartphone ou tablet as lojas de aplicativos.
                </p>
                <div className="wrapper-icon-store">
                  <a
                    style={{ marginRight: '1rem' }}
                    href="https://play.google.com/store/apps/details?id=br.com.senac.editoradigital"
                  >
                    <img alt="" width={100} className="google-play-logo" src={googlePlayLogo} />
                  </a>
                  <a href="https://apps.apple.com/br/app/biblioteca-digital-senac/id1474822168">
                    <img className="app-store-logo" width={100} src={appStoreLogo} alt="" />
                  </a>
                </div>
              </div>

              <div className="rdp-react-template-view-faq-question">
                <h2>Quais softwares de acessibilidade posso utilizar?</h2>
                <p>
                  O conteúdo da Biblioteca Digital Senac é compatível com os softwares
                  DOSVOX, NVDA e JAWS.
                </p>
              </div>

              <div className="rdp-react-template-view-faq-question">
                <h2>
                  O software de acessibilidade foi instalado, mas não está lendo o
                  conteúdo.
                </h2>
                <p>
                  Se estiver com qualquer dificuldade para utilizar algum dos recursos
                  de acessibilidade, entre em contato com a biblioteca de sua
                  instituição e informe o ocorrido.
                </p>
              </div>
            </div>
          </div>
          <Footer/>
        </div>
      </div>
    );
  }
}